<ng-content select="[slot='tootlTipTrigger']"></ng-content>
<div class="tooltip-container" #tooltip>
    <div
        *ngIf="showTooltip"
        class="d-flex flex-column tooltip-wrapper"
        [ngClass]="{ 'right-tip': tipPosition === 'right', 'left-tip': tipPosition === 'left' }"
    >
        <ng-content select="[slot='tootlTipWrapper']"></ng-content>
    </div>
</div>
